import { gql } from '@apollo/client'

export const PROVIDER_GENERATE_MUTATION = gql`
  mutation GenerateProvider($input: ProviderInput!) {
    generateProvider(input: $input) {
      message
    }
  }
`

export const PROVIDER_MODIFY_MUTATION = gql`
  mutation ModifyProvider($input: ProviderInput!, $providerCode: String!) {
    modifyProvider(input: $input, providerCode: $providerCode) {
      message
    }
  }
`

export const PROVIDER_DELETE_MUTATION = gql`
  mutation DeleteProvider($providerCode: String!) {
    deleteProvider(providerCode: $providerCode) {
      message
    }
  }
`

export const PROVIDER_ASSICIATED_NOTIFICATION_MUTATION = gql`
  mutation SaveProviderNotification(
    $input: NotificationReceiverInput!
    $code: String!
    $isChannel: Boolean!
    $isTenant: Boolean!
  ) {
    saveProviderNotification(
      input: $input
      code: $code
      ischannel: $isChannel
      isTenant: $isTenant
    ) {
      message
    }
  }
`
